/**
 * PlaybackTokenGenerator entity class
 */

/**
 * PlaybackTokenGeneratorFactory
 * returns PlaybackTokenGenerator entity class
 *
 * @class PlaybackTokenGeneratorFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.PlaybackTokenGenerator} class
 *
 * @ngdoc factory
 * @name mwApp.factory:PlaybackTokenGeneratorFactory
 */
/* @ngInject */
export default function PlaybackTokenGeneratorFactory (Type, Entity, onOffMixin) {
  /* === PlaybackTokenGenerator class === */

  /**
   * PlaybackTokenGenerator model
   *
   * @class PlaybackTokenGenerator
   * @classdesc PlaybackTokenGenerator model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.onOffMixin
   * @return {models.PlaybackTokenGenerator} PlaybackTokenGenerator entity
   */
  function PlaybackTokenGenerator () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  PlaybackTokenGenerator.prototype = Object.create(Entity.prototype)
  PlaybackTokenGenerator.prototype.constructor = PlaybackTokenGenerator

  /* === PlaybackTokenGenerator instance methods & fields === */

  Object.assign(PlaybackTokenGenerator.prototype, {

    /**
     * instance fields
     *
     * @memberof models.PlaybackTokenGenerator#
     * @type {Object}
     */
    _fields: {
      id: Number,
      name: String,
      assigned: Number, // only list
      enabled: Boolean,
      playbackTokenGeneratorType: 'AKAMAI', // PLAYBACK_TOKEN_GENERATOR_TYPES
      secretNumber: 0,
      publicKey: String,
      token: Type(String('')), // only single
      extraToken: Type(String('')), // only single
      // GET-only display mask from API (*** + last 5, or ***). Never POST.
      maskedToken: Type(String('')),
      tokenTime: 3600, // in seconds
      extraTokenTime: 3600, // in seconds
      rsaPrivateKey: String,
      ignoreClientIp: true,
      urlFormat: 'QUERYSTRING',
      protectServe: Boolean,
      $tokenTime: Number
    },

    /**
     * url template
     *
     * @memberof models.PlaybackTokenGenerator#
     * @type {String}
     */
    _urlTemplate: 'api/extensions/playbacktokengenerators/{{::id}}',

    /**
     * url template
     *
     * @memberof models.PlaybackTokenGenerator#
     * @type {String}
     */
    _publicUrlTemplate: 'extensions/playbacktokengenerators/{{::id}}',

    /**
     * Prepare entity, fill fields
     *
     * @memberof models.PlaybackTokenGenerator#
     * @override
     */
    _prepare: function () {
      this.$tokenTime = this.tokenTime / 60
    },

    /**
     * Get underlying object
     *
     * @memberof models.PlaybackTokenGenerator#
     * @return {Object} new underlying object as plain object
     * @override
     */
    _object: function () {
      var ret = Entity.prototype._object.apply(this, arguments)

      // remove fields, specific only for list
      delete ret.assigned
      // display-only mask from GET; do not send it back as the secret
      delete ret.maskedToken

      // remove Url Format for any token generation, except OnApp
      if (ret.playbackTokenGeneratorType !== 'ONAPP') {
        ret.urlFormat = null
      }

      // remove RSA Private Key for any token generation, except AWS CloudFront
      if (ret.playbackTokenGeneratorType !== 'CLOUDFRONT') {
        ret.rsaPrivateKey = null
      }

      if (ret.playbackTokenGeneratorType === 'CLOUDFRONT') {
        ret.token = ret.publicKey
      }

      return ret
    }

  }, onOffMixin)

  /* === PlaybackTokenGenerator static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(PlaybackTokenGenerator, Entity)
  PlaybackTokenGenerator._name = 'PlaybackTokenGenerator'
  PlaybackTokenGenerator._publicName = 'Playback Token Generator'
  PlaybackTokenGenerator.init()

  // permissions
  PlaybackTokenGenerator.access = {
    view: 'viewExtension',
    create: 'createExtension',
    edit: 'editExtension',
    delete: 'deleteExtension'
  }

  return PlaybackTokenGenerator
}
